import React from "react";
import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import withRoleCheck from "components/hocs/withRoleCheck";
import { CONSTANT_CONTACT_SYNC_STATUS } from "hooks/useEmailScheduleTable";
import { EMAIL_SERVICES } from "constants/Constants";
import _ScheduleModal from "routes/campaign/components/ScheduleModal";
import { DeleteScheduleModal as _DeleteScheduleModal } from "routes/campaign/components/Modals";
import CustomDropdown from "components/CustomDropdown";

const ScheduleModal = withRoleCheck(_ScheduleModal, [
  ACL_RELATIONSHIPS.campaignSchedule.create,
]);
const DeleteScheduleModal = withRoleCheck(_DeleteScheduleModal, [
  ACL_RELATIONSHIPS.campaignSchedule.delete,
]);

export function EmailScheduleTableActions({
  campaignId,
  original,
  handleSyncData,
  invalidateData,
  handleDeleteEmailSchedule,
}) {
  const id = original.id;
  const email_service = original.email_service;
  const info = original.info;
  const isSyncing =
    info?.sync_status === CONSTANT_CONTACT_SYNC_STATUS.in_progress;

  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction="left">
        <ScheduleModal
          campaignId={parseInt(campaignId)}
          newSchedule={false}
          scheduleId={id}
          fetchData={invalidateData}
          isClone={false}
        />
        <ScheduleModal
          campaignId={parseInt(campaignId)}
          newSchedule={false}
          scheduleId={id}
          fetchData={invalidateData}
          isClone={true}
        />
        <DeleteScheduleModal
          scheduleId={id}
          campaignId={campaignId}
          menuTrigger
          onConfirmDelete={() => handleDeleteEmailSchedule(campaignId, id)}
        />
        {email_service === EMAIL_SERVICES.CONSTANT_CONTACT ? (
          <>
            <Dropdown.Item
              content={isSyncing ? "Syncing..." : "Sync All"}
              onClick={() => handleSyncData(id, false, false)}
              icon="sync"
              disabled={isSyncing}
            />
            <Dropdown.Item
              content={isSyncing ? "Syncing..." : "Sync Template"}
              onClick={() => handleSyncData(id, true, false)}
              icon="sync"
              disabled={isSyncing}
            />
            <Dropdown.Item
              content={isSyncing ? "Syncing..." : "Sync Contacts"}
              onClick={() => {
                handleSyncData(id, false, true);
              }}
              icon="sync"
              disabled={!(info && info.cc_campaign_activity_id) || isSyncing}
            />
          </>
        ) : null}
      </Dropdown.Menu>
    </CustomDropdown>
  );
}
